import { FIRST_SORTABLE_COLUMN_INDEX } from '../../config/columns';

/**
 * @param {object[]} headerGroups - Header groups.
 * @returns {{
 *    headerGroup: any,
 *    sortedColumn: any,
 *    sortDirection: ('ascending'|'descending'),
 * }} Data.
 */
export const getTableSortData = headerGroups => {
    // We only have one header group so we do this to reduce the need to iterate
    // through a list.
    const headerGroup = headerGroups[ 0 ];

    const { sortedColumn, sortDirection } = ( () => {
        const _sortedColumn = headerGroup.headers.find(
            column => column.isSorted
        );

        /**
         * @type {'ascending'|'descending'}
         */
        let _sortDirection = 'descending';

        if ( !_sortedColumn ) {
            return {
                sortedColumn: headerGroup.headers[ FIRST_SORTABLE_COLUMN_INDEX ],
                sortDirection: _sortDirection
            };
        }

        _sortDirection = _sortedColumn.isSortedDesc ?
            'descending' :
            'ascending';

        return {
            sortedColumn: _sortedColumn,
            sortDirection: _sortDirection
        };
    } )();

    return { headerGroup, sortedColumn, sortDirection };
};